<template>
  <div class="d-flex flex-column justify-content-center align-items-start">
    <p class="text-secondary">Sign in to begin..</p>
    <p class="text-danger">{{errorMessage}}</p>
    <div class="mb-3">
      <label class="mb-0" for="email">Email:</label>
      <b-form-input id="email" v-model="email" type="text" placeholder="john@email.com.."></b-form-input>
    </div>
    <div class="mb-3">
      <label class="mb-0" for="email">Password:</label>
      <b-form-input v-model="password" id="password" type="password"></b-form-input>
      <b-link to="/forgot-password">forgot password?</b-link>
    </div>

    <b-button variant="primary" @click="requestLogin" class="align-self-end">Submit</b-button>
  </div>
</template>

<script>
export default {
  name: "login-card",
  data() {
    return {
      email: "",
      password: ""
    };
  },
  methods: {
    requestLogin() {
      this.$store
        .dispatch("app/login", {
          email: this.$data.email,
          password: this.$data.password
        })
        .then(() => {
          this.$router.push("/order");
        });
    }
  },
  computed: {
    errorMessage() {
      return this.$store.state.app.loginErrorMessage;
    }
  }
};
</script>

